/* ==========================================================================
   FloorEver — barre d'achat collante de la fiche produit, mobile
   (audit 16/10/2026).

   Sous 768 px, tant que le bouton « Ajouter au panier » du bloc d'achat
   n'est pas à l'écran, une barre fixe en bas propose :
   - « Échantillon » : déclenche le bouton échantillon du bloc d'achat
     (même requête, même quota, même annonce aria-live) ;
   - « Ajouter » : bouton submit rattaché au formulaire #pdp-form
     (attribut form), donc même envoi AJAX que le bouton principal.
   Les états sont RECOPIÉS du bloc d'achat, jamais recalculés :
   disabled du submit, total « — 449,50 € » ajouté au libellé, retour
   « Ajouté » de l'échantillon. Décor déjà au panier, bouton échantillon
   désactivé (ticket 3 de la recette) : « Échantillon » reste à sa place,
   désactivé, avec son libellé court ; « Déjà dans le panier » tronquerait
   le total, et retirer le bouton glisserait « Ajouter » sous le doigt.

   Sans JS : la barre reste hidden.
   ========================================================================== */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 767.98px)');

  function init(barre) {
    if (barre.dataset.pdpBarreInit) return;
    barre.dataset.pdpBarreInit = '1';

    var section = barre.closest('[data-pdp]') || barre.closest('section') || document;
    var submit = section.querySelector('[data-pdp-submit]');
    var submitLabel = section.querySelector('[data-pdp-submit-label]');
    var add = barre.querySelector('[data-pdp-barre-add]');
    var addLabel = barre.querySelector('[data-pdp-barre-label]');
    var ech = barre.querySelector('[data-pdp-barre-ech]');
    var echLabel = ech ? ech.querySelector('span') : null;
    var sample = section.querySelector('[data-pdp-sample]');
    var sampleLabel = sample ? sample.querySelector('[data-pdp-sample-label]') : null;
    if (!submit || !add) return;

    var court = addLabel ? addLabel.dataset.labelCourt : '';
    var base = submitLabel ? (submitLabel.dataset.labelBase || '') : '';
    var echCourt = echLabel ? echLabel.textContent : '';
    var sampleBase = sampleLabel ? sampleLabel.textContent : '';
    var cibleVisible = true;

    function recopier() {
      add.disabled = submit.disabled;
      if (addLabel && submitLabel && court) {
        // « Ajouter au panier — 449,50 € » -> « Ajouter — 449,50 € », montant
        // repris dans son span .btn-prix (chiffres en Schibsted).
        addLabel.textContent = court;
        var prixSrc = submitLabel.querySelector('.btn-prix');
        if (prixSrc) addLabel.appendChild(prixSrc.cloneNode(true));
      }
      if (ech && sample) {
        ech.disabled = sample.disabled;
        if (echLabel && sampleLabel) {
          var s = sampleLabel.textContent;
          echLabel.textContent = s === sampleBase || sample.disabled ? echCourt : s;
        }
      }
    }

    function afficher() {
      var montrer = MQ.matches && !cibleVisible;
      if (barre.hidden === !montrer) return;
      barre.hidden = !montrer;
    }

    // Le bouton principal ET l'échantillon : la barre ne double jamais
    // un bloc d'achat déjà visible.
    var cible = submit;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        cibleVisible = entries[0].isIntersecting;
        afficher();
      }).observe(cible);
    } else {
      cibleVisible = true;
    }

    var obs = new MutationObserver(recopier);
    obs.observe(submit, { attributes: true, attributeFilter: ['disabled'] });
    if (submitLabel) obs.observe(submitLabel, { childList: true, characterData: true, subtree: true });
    if (sample) obs.observe(sample, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });

    if (ech && sample) {
      ech.addEventListener('click', function () {
        if (!sample.disabled) sample.click();
      });
    }

    // Le formulaire peut refuser l'envoi (minimum non atteint, quantité
    // vide) : on ramène alors le bloc d'achat à l'écran pour le message.
    add.addEventListener('click', function () {
      window.setTimeout(function () {
        var alerte = section.querySelector('[data-achat-min-note]:not([hidden]), .calc-qty:invalid');
        if (alerte) alerte.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 0);
    });

    if (MQ.addEventListener) MQ.addEventListener('change', afficher);
    else if (MQ.addListener) MQ.addListener(afficher);

    recopier();
    afficher();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pdp-barre]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
